module.exports = __webpack_public_path__ + "static/media/nagel.8beeb176.jpg";